module.exports = __webpack_public_path__ + "hat-classic.254893b5b03c4e2cc649.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/hat-classic.svg
// module id = ../../../../../src/assets/img/hat-classic.svg
// module chunks = main